import React, { useEffect, useState } from "react";
import { Card, Typography, Descriptions, Spin, Row, Col } from "antd";
import axios from "axios";

const { Title, Paragraph } = Typography;

const AboutDetails = () => {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/about");
      setAbout(response.data);
    } catch (error) {
      console.error("Error fetching about section:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
      {loading ? (
        <Spin size="large" />
      ) : (
        <Card style={{ width: "80%", maxWidth: "900px", padding: "20px", borderRadius: "10px" }}>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <img src={`http://93.127.203.113:5005${about.image}`} alt="About" style={{ width: "100%", maxWidth: "300px", borderRadius: "10px" }} />
            </Col>
            <Col xs={24} md={16}>
              <Title level={3} style={{ color: "#0c8c49" }}>{about.title}</Title>
              <Paragraph><strong>Subtitle:</strong> {about.subtitle}</Paragraph>
              <Paragraph>{about.description}</Paragraph>
            </Col>
          </Row>
        </Card>
      )}
    </div>
  );
};

export default AboutDetails;
